__turbopack_context__.v({
  "motion": "sticker-treatments-module-scss-module__0zsX9W__motion",
  "stickerPop": "sticker-treatments-module-scss-module__0zsX9W__stickerPop",
  "stickerSway": "sticker-treatments-module-scss-module__0zsX9W__stickerSway",
});
